export class Microsoft365ConnectionInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appClientId",
            "baseName": "appClientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<Microsoft365GraphPermission>",
            "format": ""
        },
        {
            "name": "redirectUri",
            "baseName": "redirectUri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365ConnectionInfo.attributeTypeMap;
    }
    constructor() {
    }
}
